// extracted by mini-css-extract-plugin
export default {"moveVolumesBetweenSeasonsForObjectForm":"MoveVolumesBetweenSeasonsForObject_moveVolumesBetweenSeasonsForObjectForm__VeLdF"};